import type { ReactNode } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
interface Props { direction: "horizontal"|"vertical"; autoSaveId?: string; defaultSizes?: [number,number]; first: ReactNode; second: ReactNode; }
export function SplitPanel({ direction, autoSaveId, defaultSizes=[65,35], first, second }: Props) {
  return (
    <PanelGroup direction={direction} autoSaveId={autoSaveId} className="h-full">
      <Panel defaultSize={defaultSizes[0]} minSize={20}><div className="h-full overflow-hidden">{first}</div></Panel>
      <PanelResizeHandle className={direction==="horizontal" ? "w-px bg-[var(--color-border)] hover:bg-[var(--color-brand)]" : "h-px bg-[var(--color-border)] hover:bg-[var(--color-brand)]"} />
      <Panel defaultSize={defaultSizes[1]} minSize={15}><div className="h-full overflow-hidden">{second}</div></Panel>
    </PanelGroup>
  );
}
